export default __webpack_public_path__ + "static/media/home_ilumination.2b23f50a.png";